// PIN modal — initial render once; only dots update per keypress.

import { isPin } from '../utils/validation.js';

let currentPin = '';
let onSuccessCb = null;
let onCancelCb = null;
let validator = null;
let isValidating = false;

function modalEl() { return document.getElementById('pin-modal-host'); }

function updateDots() {
  const dots = modalEl()?.querySelectorAll('.pin-dot');
  if (!dots) return;
  dots.forEach((d, i) => {
    d.classList.toggle('filled', i < currentPin.length);
  });
}

function setError(text) {
  const err = document.getElementById('pin-error');
  if (err) err.textContent = text;
}

function initialRender(titleText) {
  const dots = Array.from({ length: 4 }, (_, i) =>
    `<span class="pin-dot" data-i="${i}"></span>`
  ).join('');

  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'del'];
  const keypad = keys.map(k => {
    if (k === '') return '<div></div>';
    if (k === 'del') return `<button class="pin-key del" data-key="del" type="button">⌫</button>`;
    return `<button class="pin-key" data-key="${k}" type="button">${k}</button>`;
  }).join('');

  let host = modalEl();
  if (!host) {
    host = document.createElement('div');
    host.id = 'pin-modal-host';
    document.body.appendChild(host);
  }

  host.innerHTML = `
    <div class="modal-overlay open" id="pin-overlay">
      <div class="modal-box" style="max-width:380px;">
        <div class="modal-title" id="pin-title">${titleText}</div>
        <div class="pin-dots" id="pin-dots">${dots}</div>
        <p id="pin-error" class="pin-error"></p>
        <div class="pin-pad" id="pin-pad">${keypad}</div>
        <button id="pin-close" class="btn btn-ghost btn-block" type="button" style="margin-top:14px;">CANCELAR</button>
      </div>
    </div>
  `;

  // Event delegation on keypad — survives all interactions, no re-render
  host.querySelector('#pin-pad').addEventListener('click', (e) => {
    const btn = e.target.closest('.pin-key');
    if (!btn) return;
    handleKey(btn.dataset.key);
  });
  host.querySelector('#pin-close').addEventListener('click', () => close(true));
}

async function handleKey(k) {
  if (isValidating) return;
  if (k === 'del') {
    currentPin = currentPin.slice(0, -1);
    updateDots();
    setError('');
    return;
  }
  if (currentPin.length >= 4) return;
  currentPin += k;
  updateDots();
  setError('');

  if (currentPin.length === 4) {
    isValidating = true;
    setError('⏳ Validando…');

    const okCb = onSuccessCb;
    const attemptedPin = currentPin;

    try {
      const ok = await validator(attemptedPin);
      if (ok) {
        modalEl()?.remove();
        currentPin = '';
        onSuccessCb = null;
        onCancelCb = null;
        validator = null;
        isValidating = false;
        if (okCb) okCb(attemptedPin);
      } else {
        setError('❌ PIN incorrecto');
        currentPin = '';
        updateDots();
        isValidating = false;
      }
    } catch (e) {
      console.error('[pin-modal] validation error', e);
      setError('❌ ' + (e.message || 'Error'));
      currentPin = '';
      updateDots();
      isValidating = false;
    }
  }
}

function close(isCancel = false) {
  const cancelCb = onCancelCb;
  modalEl()?.remove();
  currentPin = '';
  onSuccessCb = null;
  onCancelCb = null;
  validator = null;
  isValidating = false;
  if (isCancel && cancelCb) cancelCb();
}

export function openPinModal({ title = '🔐 PIN', validate, onSuccess, onCancel } = {}) {
  validator = typeof validate === 'function' ? validate : (pin) => isPin(pin);
  onSuccessCb = onSuccess;
  onCancelCb = onCancel;
  currentPin = '';
  isValidating = false;
  initialRender(title);
}

if (typeof window !== 'undefined') window.openPinModal = openPinModal;
